<template>
  <div class="section sec4" :class="{activepage:showIndex==3}">
    <div class="section-contain">
      <div class="sec-header">
        <div class="header-title">医信管家的特点</div>
      </div>
      <div class="sec-body">
        <div class="sec-item" v-for="(item, index) in fourthPageInfo.itemList" :key="'fourthPage_'+index" :class="{right:item.align=='right'}">
          <div class="sec-item-icon">
            <img :src="item.imgurl" alt />
          </div>
          <div class="sec-item-detail">
            <div class="sec-item-title">{{item.title}}</div>
            <div class="sec-item-content">{{item.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <footer-common @toTop="toTop"></footer-common>
  </div>
</template>

<script>
import footerCommon from '../common/footerCommon';
export default {
    name: "HelloWorld",
    props: ["showIndex","fourthPageInfo"],
    data() {
        return {
            qrCode: false
        };
    },
    components: {
        footerCommon
    },
    methods: {
        toTop() {
            this.$emit("toTop");
        },
        beianLink(link){
            if (link!==""){
                window.open(link);
            }
        }
    },
    mounted () {
    }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.sec-header {
  font-size: 32px;
  color: #333;
  margin-bottom: 62px;
}
.sec4 .section-contain {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

/* .sec4 .sec .sec-body {
  display: flex;
  flex-wrap: wrap;

} */

.sec-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 400px;
  width: 934px;
}

.sec-body .sec-item {
  height: 101px;
  width: 428px;
  background-color: #fff;
  padding-left: 78px;
  position: relative;
  box-sizing: border-box;
}

/* .sec-body .sec-item.right {
  padding: 0;
  padding-right: 78px;
} */

/* .sec-body .sec-item.right .sec-item-title,
.sec-body .sec-item.right .sec-item-content {
  text-align: right;
} */

/* .sec-body .sec-item:hover {
  background: #f7fafc;
} */

.sec-body .sec-item .sec-item-icon {
  position: absolute;
  top: 0;
  left: 0;
  height: 52px;
  height: 52px;
}

/* .sec-body .sec-item .sec-item-icon{
    left:0;
} */

/* .sec-body .sec-item.right .sec-item-icon {
  left: 100%;
  transform: translateX(-52px);
} */

.sec-body .sec-item .sec-item-title {
  color: #333;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  font-weight: bold;
  /* margin-bottom: 10px; */
  margin-bottom: 5px;
}

.sec-body .sec-item .sub-title {
  display: inline-block;
  width: 84px;
  font-size: 12px;
  color: #00a0e9;
  background-color: #e5f7ff;
  border-radius: 3px;
  line-height: 20px;
  height: 20px;
  text-align: center;
  margin-left: 10px;
  /* margin-top:-2px; */
  font-weight: normal;
}

.sec-body .sec-item .sec-item-content {
  /* height: 67px;  1920 */
  height: 45px;
  width: 350px;
  word-break: break-all;
  word-wrap: break-word;
  color: #888;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  letter-spacing: -1px;
}


.linker{
  cursor:pointer;
  text-decoration: underline;
}
.linker:hover{
  color:#ddd;
}
.sec4 .footer-style{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
}
.sec4 .sec-footer .other {
  position: absolute;
  right: 40px;
  bottom: 20px;
}
.sec4 .sec-footer .other > div {
  display: inline-block;
  margin-left: 5px;
  position: relative;
}

.sec4 .sec-footer .other .qr-code {
  position: absolute;
  bottom: 100%;
  left: -100%;
  transform: translateY(-10px);
  z-index: 150;
}

/* 动画效果 */
.sec4.activepage .sec-header {
  animation: title 1s linear;
  animation-fill-mode: forwards;
}
.sec4.activepage .sec-body {
  animation: body 1.5s linear;
  animation-fill-mode: forwards;
}

@keyframes title {
  0% {
    opacity: 0;
    margin-left: -100px;
  }
  100% {
    opacity: 1;
    margin-left: 0;
  }
}

@keyframes body {
  0% {
    opacity: 0;
    width: 1100px;
  }

  100% {
    opacity: 1;
    width: 934px;
  }
}

@media screen and (max-width: 1366px) {
  .sec4 .section-contain {
    top: calc(50% - 20px);
  }
  .sec-header {
    margin-bottom: 38px;
  }

  .sec-body {
    height: 341px;
  }
  /* .sec-body .sec-item .sec-item-title {
    margin-bottom: 5px;
  }*/

  .sec-body .sec-item {
    height: 94px;
  }
  .sec-body .sec-item .sec-item-content {
    height: 45px;
    letter-spacing: -1px;
  }
}

@media screen and (min-width: 1920px) {
  .sec-header {
    margin-bottom: 62px;
  }
  .sec-body {
    height: 500px;
  }
  .sec-body .sec-item .sec-item-title {
    margin-bottom: 10px;
  }

  .sec-body .sec-item .sec-item-content {
    height: 67px;
    /* letter-spacing: -1px; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/fourthPage.vue